var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    [
      _vm.masavFile
        ? _c("masav-file-details", { attrs: { model: _vm.masavFile } })
        : _vm._e(),
      _c(
        "v-card",
        { staticClass: "mx-auto", attrs: { flat: "", loading: _vm.loading } },
        [
          _c(
            "div",
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.masavFileRows,
                  "item-class": _vm.row_classes,
                  options: _vm.options,
                  "server-items-length": _vm.totalAmount,
                  loading: _vm.loading,
                  "header-props": { sortIcon: null }
                },
                on: {
                  "update:options": function($event) {
                    _vm.options = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.masavFileRowID",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm.selectable && item.isPayed
                          ? _c("v-checkbox", {
                              attrs: {
                                checked: _vm.existSelectedRows(
                                  item.masavFileRowID
                                ),
                                label: item.masavFileRowID.toString()
                              },
                              on: {
                                click: function($event) {
                                  return _vm.updateSelectedRows(
                                    item.selected,
                                    item.masavFileRowID
                                  )
                                }
                              },
                              model: {
                                value: item.selected,
                                callback: function($$v) {
                                  _vm.$set(item, "selected", $$v)
                                },
                                expression: "item.selected"
                              }
                            })
                          : _c("span", [_vm._v(_vm._s(item.masavFileRowID))])
                      ]
                    }
                  },
                  {
                    key: "item.amount",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("b", { staticClass: "text-center" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(item.amount, item.currency)
                            )
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.smsSent",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          _vm._s(item.smsSent ? _vm.$t("Yes") : _vm.$t("No"))
                        )
                      ]
                    }
                  },
                  {
                    key: "item.paymentTransactionID",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.$paymentTransactionID
                          ? _c(
                              "router-link",
                              {
                                staticClass: "primary--text",
                                attrs: {
                                  link: "",
                                  to: {
                                    name: "Transaction",
                                    params: { id: item.$paymentTransactionID }
                                  }
                                }
                              },
                              [
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("guid")(item.paymentTransactionID)
                                    )
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }